/** Lifecycle of the "What we planted" slot (spec §3.1): the module shows for
 *  7 days after seeding OR 5 home visits, whichever comes first, and any
 *  manual dismiss ends it early. Afterwards the slot becomes the Season strip. */

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
const VISIT_CAP = 5;

export function plantedPhase(input: {
  seededAt: string | null;
  plantedCollapsedAt: string | null;
  visits: number;
  now?: Date;
}): "planted" | "season" | "none" {
  if (!input.seededAt) return "none";
  if (input.plantedCollapsedAt) return "season";
  const now = (input.now ?? new Date()).getTime();
  const seeded = new Date(input.seededAt).getTime();
  if (now - seeded >= WEEK_MS) return "season";
  if (input.visits >= VISIT_CAP) return "season";
  return "planted";
}

export const PLANTED_VISITS_KEY = "planted_visits";

/** Bump the per-device home-visit counter; returns the new count. */
export function bumpPlantedVisits(): number {
  try {
    const raw = Number(localStorage.getItem(PLANTED_VISITS_KEY) ?? "0");
    const n = (Number.isFinite(raw) ? raw : 0) + 1;
    localStorage.setItem(PLANTED_VISITS_KEY, String(n));
    return n;
  } catch {
    return 0;
  }
}
